import { render, staticRenderFns } from "./ImageGrid.vue?vue&type=template&id=27dd19da&"
import script from "./ImageGrid.vue?vue&type=script&lang=ts&"
export * from "./ImageGrid.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports